import { cn } from './cn';

type Props = { page: number; pages: number; total: number; pageSize: number; onChange: (page: number) => void; className?: string };

/** Pagination à cases (page active pleine), avec le décompte des résultats. */
export default function Pagination({ page, pages, total, pageSize, onChange, className }: Props) {
  if (total === 0) return null;
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);

  const items: (number | '…')[] = [];
  for (let n = 1; n <= pages; n++) {
    if (n === 1 || n === pages || Math.abs(n - page) <= 1) items.push(n);
    else if (items[items.length - 1] !== '…') items.push('…');
  }

  const box = 'flex h-10 min-w-10 items-center justify-center border border-brand px-2 text-sm font-semibold transition-colors';
  return (
    <div className={cn('mt-14', className)}>
      {pages > 1 && (
        <nav aria-label="Pagination" className="flex items-center">
          {items.map((n, i) =>
            n === '…' ? (
              <span key={`gap-${i}`} className={cn(box, 'text-ink')}>…</span>
            ) : (
              <button key={n} aria-current={n === page ? 'page' : undefined} onClick={() => onChange(n)} className={cn(box, n === page ? 'bg-brand text-charcoal' : 'bg-white text-charcoal hover:bg-brand-tint-soft')}>{n}</button>
            ),
          )}
          {page < pages && (
            <button aria-label="Page suivante" onClick={() => onChange(page + 1)} className="ml-3 flex h-10 w-10 items-center justify-center text-charcoal hover:text-brand-dark">
              <svg viewBox="0 0 8 12" className="h-3 w-2" fill="none" stroke="currentColor" strokeWidth="1.6"><path d="M1 1l5 5-5 5" /></svg>
            </button>
          )}
        </nav>
      )}
      <p className="mt-5 text-sm text-black">Affichage {from}–{to} sur {total} résultat{total > 1 ? 's' : ''}</p>
    </div>
  );
}
